import React from "react";
import MultiRowCarousel from "../../MultiRowsCarousel";
import leftArrow from "../../../../../assets/shapes_svg/ambition/left-arrow.svg";
import rightArrow from "../../../../../assets/shapes_svg/ambition/right-arrow.svg";
import "./index.css";
import { useNavigate } from "react-router-dom";

export const PurchasingList = ({
  className,
  newName,
  setNewName,
  handleSave,
  efforts,
  link,
  // onEffortSelect,
}) => {
  const navigate = useNavigate();
  const handleItemClick = (item) => {
    // if (onEffortSelect) {
    //   onEffortSelect(item);
    // }
    navigate(link);
  };

  const ButtonGroup = ({ onNext, onPrevious }) => {
    return (
      <div className="carousel-navigation">
        <img
          src={leftArrow}
          onClick={onPrevious}
          alt="Previous"
          className="purchasing-nav-button"
        />
        <img
          src={rightArrow}
          onClick={onNext}
          alt="Next"
          className="purchasing-nav-button"
        />
      </div>
    );
  };

  const renderItem = (item) => (
    <div className="purchase-action-item" onClick={() => handleItemClick(item)}>
      <h4>{item.name}</h4>
    </div>
  );

  return (
    <div className="purchase-action-container">
      <MultiRowCarousel
        containerClassName="purchase"
        items={efforts}
        rowsPerSlide={2}
        itemsPerRow={3}
        CustomButtonGroup={ButtonGroup}
        renderItem={renderItem}
        className={className}
        newName={newName}
        setNewName={setNewName}
        handleSave={handleSave}
        link={link}
        // onEffortSelect={onEffortSelect}
      />
    </div>
  );
};
